import { defineStore } from 'pinia';

const name = 'subscription';

export default defineStore(name, {
  state: () => ({
    subscriptionCode: -1 as number,
    limitLen: 0 as number,
    leftLen: 0 as number,
    tryToFreeGenNum: 0 as number,
    popPrivateClone: 0 as number,
    upgradeSubGroupIndex: -1 as number,
  }),
  actions: {},
});
